export default __webpack_public_path__ + "static/media/header2.e83f95f0.jpg";